<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/price-region" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ ViewPriceRegion.regionName }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletepriceRegionPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Id") }}</b>
                    </td>
                    <td>{{ ViewPriceRegion.id }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.RegionCode") }}</b>
                    </td>
                    <td>{{ ViewPriceRegion.regionCode }}</td>
                  </tr>

                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.RegionName") }} </b>
                    </td>
                    <td class="border-none">
                      {{ ViewPriceRegion.regionName }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletepriceRegionPopup"
      :title="$t('setup.label.DeletePriceRegion')"
      @deletePressed="deletepriceRegion()"
      @cancelPressed="deletepriceRegionPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      ViewPriceRegion: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deletepriceRegionPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      PriceRegion: (state) => state.priceRegion.PriceRegionList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push({ name: "Edit Price Region", params: { id: id } });
    },
    async deletepriceRegion() {
      this.deletepriceRegionPopup = false;
      await this.$store.dispatch(
        "priceRegion/deletepriceRegionAction",
        this.id
      );
      this.$router.push(`/setup/price-region`);
    },

    async getPriceRegions() {
      try {
        await this.$store.dispatch("priceRegion/setPriceRegions", this.id);
        this.ViewPriceRegion = this.PriceRegion;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getPriceRegions();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
